import { useMemo, useState } from 'react';
import { useSpace } from '../../../hooks/useSpace';
import { usePermissions } from '../../../hooks/usePermissions';
import { useGetMeetings } from '../api/getMeetings';
import { groupMeetings } from '../utils/groupMeetings';

export function useMeetingsPage() {
  const { currentSpace } = useSpace();
  const { isAdmin } = usePermissions();
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);

  const { data: meetings = [], isLoading, isError } = useGetMeetings(currentSpace?.id);

  const { upcoming, pastByYear } = useMemo(() => groupMeetings(meetings), [meetings]);

  return {
    isAdmin,
    isLoading,
    isError,
    isEmpty: !isLoading && !isError && meetings.length === 0,
    upcoming,
    pastByYear,
    isCreateModalOpen,
    handleOpenCreateModal: () => setIsCreateModalOpen(true),
    handleCloseCreateModal: () => setIsCreateModalOpen(false),
  };
}
